import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEn from './en/common.json';
import authEn from './en/auth.json';
import dashboardEn from './en/dashboard.json';
import sessionEn from './en/session.json';
import accountEn from './en/account.json';
import homepageEn from './en/homepage.json';
import raphaEn from './en/rapha.json';
import raphaGateEn from './en/rapha-gate.json';
import subscriptionEn from './en/subscription.json';
import sessionDetailEn from './en/session-detail.json';
import analyticsEn from './en/analytics.json';
import aboutEn from './en/about.json';
import raphaFitEn from './en/rapha-fit.json';

import commonKo from './ko/common.json';
import authKo from './ko/auth.json';
import dashboardKo from './ko/dashboard.json';
import sessionKo from './ko/session.json';
import accountKo from './ko/account.json';
import homepageKo from './ko/homepage.json';
import raphaKo from './ko/rapha.json';
import raphaGateKo from './ko/rapha-gate.json';
import subscriptionKo from './ko/subscription.json';
import sessionDetailKo from './ko/session-detail.json';
import analyticsKo from './ko/analytics.json';
import aboutKo from './ko/about.json';
import raphaFitKo from './ko/rapha-fit.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEn,
        auth: authEn,
        dashboard: dashboardEn,
        session: sessionEn,
        account: accountEn,
        homepage: homepageEn,
        rapha: raphaEn,
        'rapha-gate': raphaGateEn,
        subscription: subscriptionEn,
        'session-detail': sessionDetailEn,
        analytics: analyticsEn,
        about: aboutEn,
        'rapha-fit': raphaFitEn,
      },
      ko: {
        common: commonKo,
        auth: authKo,
        dashboard: dashboardKo,
        session: sessionKo,
        account: accountKo,
        homepage: homepageKo,
        rapha: raphaKo,
        'rapha-gate': raphaGateKo,
        subscription: subscriptionKo,
        'session-detail': sessionDetailKo,
        analytics: analyticsKo,
        about: aboutKo,
        'rapha-fit': raphaFitKo,
      },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ko'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'aerochat_lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
